var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureVm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22254_197384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9733 1.16016H0.573316C0.131488 1.16016 -0.226685 1.51833 -0.226685 1.96016V16.3602C-0.226685 16.802 0.131488 17.1602 0.573316 17.1602H22.9733C23.4151 17.1602 23.7733 16.802 23.7733 16.3602V1.96016C23.7733 1.51833 23.4151 1.16016 22.9733 1.16016Z",
    fill: "url(#paint0_linear_22254_197384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2.49414H1.54669C1.30368 2.49414 1.10669 2.69114 1.10669 2.93414V15.3875C1.10669 15.6305 1.30368 15.8275 1.54669 15.8275H22C22.243 15.8275 22.44 15.6305 22.44 15.3875V2.93414C22.44 2.69114 22.243 2.49414 22 2.49414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7733 6.82617V11.4795L11.7733 13.8262V9.15951L15.7733 6.82617Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7733 6.82747L11.7733 9.17414L7.77332 6.82747L11.7733 4.49414L15.7733 6.82747Z",
    fill: "#83B9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7733 9.17284V13.8262L7.77332 11.4795V6.82617L11.7733 9.17284Z",
    fill: "#5EA0EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.77332 11.4802L11.7733 9.16016V13.8268L7.77332 11.4802Z",
    fill: "#83B9F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.7733 11.4802L11.7733 9.16016V13.8268L15.7733 11.4802Z",
    fill: "#5EA0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5867 22.0002C14.2133 21.6268 14.12 19.9202 14.12 17.1602H9.41334C9.41334 19.9202 9.33334 21.6268 6.96001 22.0002C6.63238 22.0364 6.3298 22.1927 6.11065 22.439C5.89151 22.6852 5.77134 23.0039 5.77334 23.3335H17.7733C17.7753 23.0039 17.6552 22.6852 17.436 22.439C17.2169 22.1927 16.9143 22.0364 16.5867 22.0002Z",
    fill: "url(#paint1_linear_22254_197384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80003 3.42589H3.49336C3.38894 3.42412 3.28521 3.44316 3.18822 3.48191C3.09123 3.52065 3.00293 3.57831 2.92846 3.65154C2.854 3.72476 2.79486 3.81208 2.75449 3.9084C2.71413 4.00473 2.69334 4.10812 2.69336 4.21256V7.51923C2.69336 7.62531 2.7355 7.72706 2.81052 7.80207C2.88553 7.87708 2.98727 7.91923 3.09336 7.91923H3.36003C3.46611 7.91923 3.56785 7.87708 3.64287 7.80207C3.71788 7.72706 3.76003 7.62531 3.76003 7.51923V4.46589H6.80003C6.90611 4.46589 7.00785 4.42375 7.08287 4.34874C7.15788 4.27372 7.20003 4.17198 7.20003 4.06589V3.81256C7.19657 3.7088 7.1529 3.61045 7.07826 3.5383C7.00361 3.46614 6.90384 3.42584 6.80003 3.42589Z",
    fill: "#5EA0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80003 13.8267H3.74669V10.7867C3.74669 10.6806 3.70455 10.5789 3.62954 10.5039C3.55452 10.4289 3.45278 10.3867 3.34669 10.3867H3.09336C2.98727 10.3867 2.88553 10.4289 2.81052 10.5039C2.7355 10.5789 2.69336 10.6806 2.69336 10.7867V14.0934C2.69334 14.1978 2.71413 14.3012 2.75449 14.3975C2.79486 14.4939 2.854 14.5812 2.92846 14.6544C3.00293 14.7276 3.09123 14.7853 3.18822 14.824C3.28521 14.8628 3.38894 14.8818 3.49336 14.8801H6.80003C6.90384 14.8801 7.00361 14.8398 7.07826 14.7676C7.1529 14.6955 7.19657 14.5971 7.20003 14.4934V14.2267C7.20003 14.1742 7.18968 14.1222 7.16958 14.0736C7.14948 14.0251 7.12001 13.981 7.08287 13.9439C7.04572 13.9067 7.00163 13.8773 6.9531 13.8572C6.90457 13.8371 6.85255 13.8267 6.80003 13.8267Z",
    fill: "#5EA0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3.45299H16.7467C16.6936 3.45113 16.6408 3.4602 16.5914 3.47964C16.5421 3.49909 16.4972 3.52848 16.4597 3.56601C16.4222 3.60353 16.3928 3.64837 16.3733 3.69774C16.3539 3.74712 16.3448 3.79996 16.3467 3.85299V4.10633C16.3466 4.15824 16.3571 4.20964 16.3773 4.25744C16.3976 4.30525 16.4273 4.34848 16.4646 4.38456C16.5019 4.42065 16.5461 4.44885 16.5946 4.46748C16.6431 4.4861 16.6948 4.49478 16.7467 4.49299H19.7867V7.55966C19.7866 7.61158 19.7971 7.66297 19.8173 7.71078C19.8376 7.75858 19.8673 7.80181 19.9046 7.8379C19.9419 7.87398 19.9861 7.90218 20.0346 7.92081C20.0831 7.93944 20.1348 7.94812 20.1867 7.94633H20.4533C20.5559 7.94633 20.6542 7.90559 20.7268 7.83307C20.7993 7.76056 20.84 7.66221 20.84 7.55966V4.25299C20.8421 4.14392 20.8215 4.03561 20.7795 3.93493C20.7375 3.83426 20.675 3.74342 20.596 3.66818C20.517 3.59295 20.4232 3.53497 20.3206 3.49792C20.218 3.46088 20.1088 3.44558 20 3.45299Z",
    fill: "#5EA0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4533 10.4141H20.2C20.0939 10.4141 19.9922 10.4562 19.9172 10.5312C19.8421 10.6062 19.8 10.708 19.8 10.8141V13.8541H16.7467C16.6936 13.8522 16.6408 13.8613 16.5914 13.8807C16.5421 13.9002 16.4972 13.9296 16.4597 13.9671C16.4222 14.0046 16.3928 14.0494 16.3733 14.0988C16.3539 14.1482 16.3448 14.201 16.3467 14.2541V14.5207C16.3467 14.6268 16.3888 14.7286 16.4638 14.8036C16.5388 14.8786 16.6406 14.9207 16.7467 14.9207H20C20.1044 14.9207 20.2078 14.9 20.3042 14.8596C20.4005 14.8192 20.4878 14.7601 20.561 14.6856C20.6343 14.6112 20.6919 14.5229 20.7307 14.4259C20.7694 14.3289 20.7884 14.2252 20.7867 14.1207V10.8141C20.788 10.7186 20.7551 10.6258 20.694 10.5524C20.6329 10.479 20.5475 10.43 20.4533 10.4141Z",
    fill: "#5EA0EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22254_197384",
    x1: 11.7733,
    y1: 17.1602,
    x2: 11.7733,
    y2: 1.16016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5EA0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22254_197384",
    x1: 11.7733,
    y1: 23.3335,
    x2: 11.7733,
    y2: 17.1602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1490DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1F56A3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22254_197384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureVm);
export default __webpack_public_path__ + "static/media/AzureVM.6db87db3fefb651db760ada30e4a6bb3.svg";
export { ForwardRef as ReactComponent };